@if (uniqueDevices.length > 0 && !isDeleting) {
  <sh-wrapper id="chathistory-wrapper-1" direction='column' spacing='s' style="margin-top: -4px;">
    @for (device of uniqueDevices | historySort; track device.serial + '-' + device.material) {
      <div>
        <sh-divider id="chathistory-divider-2" style="margin-top: -8px; padding-top: 4px; padding-bottom: 8px;"></sh-divider>
        <div style="display: flex; align-items: center; justify-content: space-between; padding-bottom: 4px;">
          <div style="display: flex; align-items: center; gap: 8px; flex: 1 0 auto;">
            <sh-icon id="chathistory-icon-laboratory-system" icon="laboratory-system" size="xs"></sh-icon>
            <sh-text id="chathistory-text-4" size='title-1' color="primary">{{ device.serial === noneDeviceSpecific ? (noneDeviceSpecificTranslationKey | transloco) : device.serial }}@if (checkIfDupSerial(device.serial)) {
              ({{ 'chathistory.materialLabel' | transloco }}: {{ device.material === noneDeviceSpecific ? (noneDeviceSpecificTranslationKey | transloco) : device.material }})
            }</sh-text>
          </div>
          <!-- Show More -->
          @if (checkIfExpandable(device.serial) && !expanded.get(device.serial)) {
            <div (click)="expandHistory(device.serial, true)"
              class="expandHistory">
              <sh-text id="chathistory-text-5" tabindex="0" divider="none" style="width: auto; color: #999999" class="expandHistoryContent">
                {{ 'chathistory.more' | transloco }}
              </sh-text>
              <sh-icon id="chathistory-icon-arrow-line-down-s" icon="arrow-line-down-s" size="xs" color="#999999" class="expandHistoryContent"></sh-icon>
            </div>
          }
          <!-- Show Less -->
          @if (checkIfExpandable(device.serial) && expanded.get(device.serial)) {
            <div (click)="expandHistory(device.serial, false)"
              class="expandHistory">
              <sh-text id="chathistory-text-7" tabindex="0" divider="none" style="width: auto; color: #999999" class="expandHistoryContent">
                {{ 'chathistory.less' | transloco }}
              </sh-text>
              <sh-icon id="chathistory-icon-arrow-line-up-s" icon="arrow-line-up-s" size="xs" color="#999999" class="expandHistoryContent"></sh-icon>
            </div>
          }
        </div>
        <sh-list id="chathistory-list-9" flat integrated>
          @for (chat of chatHistory | deviceFilter: device.serial : expanded.get(device.serial); track (chat.uuid || (chat.chatId + '-' + chat.number))) {
            <sh-list-item id="chathistory-list-item-10" tabindex="0" style="transition: height 0.3s ease;"
              divider="none" clickable (click)="openChat(chat['chatId'])">
              {{cropChat(chat["text"])}}
              <sh-icon id="chathistory-icon-delete" icon="delete" size="xs" button slot="right"
              (click)="markForDelete(chat['chatId'], $event)"></sh-icon>
            </sh-list-item>
          }
        </sh-list>
      </div>
    }
  </sh-wrapper>
}

@if (isDeleting || isLoading) {
  <div style="height: 150px; display: flex; justify-content: center; align-items: center;">
    <sh-spinner id="chathistory-spinner-12" size="s"></sh-spinner>
  </div>
}

@if (isError) {
  <div style="flex: 1 0 100%; min-height: 0; display: flex; align-items: center; padding-top: 32px;">
    @if (isError) {
      <sh-empty-state id="chathistory-empty-state-error-retrieving-chat-his" [attr.label]="'chathistory.error' | transloco" icon="error"
      icon-color="#ebebe"></sh-empty-state>
    }
  </div>
}

<!-- modal -->
<sh-modal sticky id='sticky-modal' [attr.label]="'chathistory.deleteModal.title' | transloco" modal-height='auto' modal-width='320px'
  [visible]="deleteModalOpen">
  <div
    style="min-height: 75px; display: flex; flex-direction: column; height: 100%; gap: 8px; justify-content: space-between;">
    {{ 'chathistory.deleteModal.message' | transloco }}
    <sh-checkbox id="chathistory-checkbox-dont-show-this-message-ag" (active-changed)="setConfirmation($event)" [attr.label]="'chathistory.deleteModal.dontShowAgain' | transloco"></sh-checkbox>
  </div>

  @if (isDeleting) {
    <sh-spinner id="chathistory-spinner-15" size="s"></sh-spinner>
  }

  <sh-button id="chathistory-button-16" [disabled]="isDeleting" color='secondary' slot='footer' [attr.label]="'chathistory.deleteModal.cancel' | transloco"
  (click)="closeModal()"></sh-button>
  <sh-button id="chathistory-button-delete" [disabled]="isDeleting" icon="delete" icon-position="left" slot='footer' [attr.label]="'chathistory.deleteModal.yes' | transloco"
  (click)="deleteChat()"></sh-button>
</sh-modal>